import { configureStore } from '@reduxjs/toolkit'
import authSlice from './reducers/auth'
import globalSlice from './reducers/global'
import homeSlice from './reducers/home'
import kycReducer from './reducers/kyc'
import leadSlice from './reducers/lead'
import businessSlice from './reducers/business'
import opportunityReducer from './reducers/opportunitySlice'
import productsReducerV3 from './reducers/productsSliceV3'
import plansReducerV3 from './reducers/plansSliceV3'
import timerSlice from './reducers/timerSlice'
import mdrProductReducer from './reducers/mdrProductSlice'

const store = configureStore({
  reducer: {
    auth: authSlice,
    globalData: globalSlice,
    homeData: homeSlice,
    lead: leadSlice,
    kyc: kycReducer,
    opportunity: opportunityReducer,
    business: businessSlice,
    productsV3: productsReducerV3,
    plansV3: plansReducerV3,
    timer: timerSlice,
    mdrProduct: mdrProductReducer,
  },
})

export type RootState = ReturnType<typeof store.getState>
export type AppDispatch = typeof store.dispatch
export default store
